define('routes',{
  // Sample Route Definition
  // 'routePath': { name: 'route name', controller: 'ControllerName' }

  // You can register your controller using the following syntext:
  // radioRequests: {
  //   'controllers ControllerName': '@constructor'
  // }

  // default should always land on the person details
  '*default': { name: 'default', controller: 'PersonDetailController' },

  // profile
  name: { name: 'profile:detail', controller: 'PersonDetailController' },

  // contact info
  contactinfo: { name: 'contactinfo:detail', controller: 'ContactDetailController' },

  //    -associations
  internalassociations: { name: 'internalassociations:list', controller: 'InternalAssociationsListController' },
  'internalassociations/:primaryId/detail/:id': {
    name: 'internalassociations:detail',
    controller: 'PeopleInternalAssociationsDetailController',
  },

  //    -roles
  roles: { name: 'roles:list', controller: 'UserAccountAndRolesController' },

  //    - external associations
  externalassociations: {
    name: 'externalassociations:list',
    controller: 'ExternalAssociationsListController',
  },
  'externalassociations/detail/:id': {
    name: 'externalassociations:detail',
    controller: 'ExternalAssociationsDetailController',
  },
  'externalassociations/create': {
    name: 'externalassociations:create',
    controller: 'ExternalAssociationsDetailController',
    stateDefaults: { authorizationMode: 'create' },
  },

  //    -trainings & certifications
  trainings: { name: 'trainings:list', controller: 'TrainingsListController' },

  //    - COI Disclosures
  disclosures: { name: 'disclosures:list', controller: 'DisclosuresListController' },
});

